import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import wentWrongCss from "./WentWrong.module.css";
import wentWrong from "../../asset/Image/error.svg";
export default function WentWrong() {
  return (
    <>
      <Container className="text-center">
        <Row>
          <Col>
            <img
              className={`${wentWrongCss.errorImg}`}
              src={wentWrong}
              alt=""
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}
